import React from 'react';
import PropTypes from 'prop-types';

import { VpTagInput } from '../..';
import { useFetchTags, useUpdateMediaTags, useUpdateAttachmentTags } from '../../../hooks';

export const VpMediaTagInput = ({ value, mediaId, isVideo }) => {
  const { data: tagData } = useFetchTags();
  const { mutate: updateMediaTags } = useUpdateMediaTags();
  const { mutate: updateAttachmentTags } = useUpdateAttachmentTags();
  const onChange = (value) => {
    const oldTags = value.filter((val) => !val.inputValue);
    const newTags = value.filter((val) => val.inputValue);
    const data = {
      tags: oldTags.map((tag) => tag?.id),
      newTags: newTags.map((tag) => tag?.inputValue)
    };

    isVideo
      ? updateMediaTags({ mediaId, data })
      : updateAttachmentTags({ attachmentId: mediaId, data });
  };

  const TagLabel = isVideo ? 'Media Tags' : 'Attachment Tags';
  return <VpTagInput options={tagData || []} value={value} onChange={onChange} label={TagLabel} />;
};

VpMediaTagInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.object),
  mediaId: PropTypes.string,
  isVideo: PropTypes.bool
};

export default VpMediaTagInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/media-details/VpMediaTagInput.jsx